{% block swag_cms_extensions_block_custom_form %}
    <div class="sw-cms-block-custom-form">
        <slot name="content"></slot>
    </div>
{% endblock %}
